import _sfc_main from "./FormControl.vue2.js";
/* empty css                 */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const FormControl = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-add19545"]]);
export {
  FormControl as default
};
//# sourceMappingURL=FormControl.vue.js.map
